import React from 'react';
interface CardProps {
  title?: string;
  subtitle?: string;
  icon?: React.ReactNode;
  actions?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  noPadding?: boolean;
}
const Card: React.FC<CardProps> = ({
  title,
  subtitle,
  icon,
  actions,
  children,
  className = '',
  noPadding = false
}) => {
  return <div className={`bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden ${className}`} data-id="element-160">
      {(title || subtitle || icon || actions) && <div className="px-6 py-4 border-b border-gray-200 flex items-center justify-between" data-id="element-161">
          <div className="flex items-center space-x-3" data-id="element-162">
            {icon && <div className="flex-shrink-0 text-gray-500" data-id="element-163">{icon}</div>}
            <div data-id="element-164">
              {title && <h3 className="text-lg font-medium text-gray-900" data-id="element-165">{title}</h3>}
              {subtitle && <p className="text-sm text-gray-500" data-id="element-166">{subtitle}</p>}
            </div>
          </div>
          {actions && <div className="flex items-center space-x-2" data-id="element-167">{actions}</div>}
        </div>}
      <div className={noPadding ? '' : 'p-6'} data-id="element-168">{children}</div>
    </div>;
};
export default Card;